<template>
  <v-menu
    :close-on-content-click="false"
    v-model="menuOpened"
    :nudge-width="450"
    max-width="600"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <v-btn icon
             v-on="on"
             @click.stop.prevent=""
      >
        <v-icon>{{ icon }}</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-text class="text--primary">
        <v-row class="title">
          <v-col cols="12">
            {{ comprador.pessoa.nome }}
          </v-col>
        </v-row>
        <v-skeleton-loader
          :loading="loadingDetalhes"
          max-width="150"
          type="text"
        >
          <v-row>
            <v-col cols="12">
              <px-show-avaliacao-icon-simple v-if="avaliacao"
                                             span-class="text--primary"
                                             :avaliacao="avaliacao.pontuacaoMedia"/>
            </v-col>
          </v-row>
        </v-skeleton-loader>
        <v-row class="">
          <v-col cols="12">
            <v-icon>mdi-domain</v-icon>
            {{ comprador.pessoa.cnpj | cnpj }}
            <px-regime-tributario :regime-tributario="comprador.pessoa.regimeTributario"/>
          </v-col>
        </v-row>
        <v-row v-if="comprador.pessoa.inscricaoEstadual">
          <v-col cols="12">
            <span class="body-1 font-weight-bold pr-2">IE</span>
            {{ comprador.pessoa.inscricaoEstadual }}
          </v-col>
        </v-row>
        <v-row v-if="comprador.site">
          <v-col cols="12">
            <v-icon>mdi-web</v-icon>
            {{ comprador.site }}
            <px-open-site :site-desc="comprador.site"></px-open-site>
          </v-col>
        </v-row>
        <v-row class="">
          <v-col cols="12">
            <v-icon>mdi-map-marker</v-icon>
            {{ comprador.endereco | endereco }}
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import CompradorService from '@/api/comprador-service';

export default {
  props: {
    icon: {
      type: String,
      default: 'mdi-chevron-down',
    },
    comprador: Object,
  },
  data: () => ({
    menuOpened: false,
    avaliacao: null,
    loading: false,
    loadingDetalhes: false,
  }),
  methods: {
    getAvaliacao() {
      this.loadingDetalhes = true;
      CompradorService.getAvaliacao(this.comprador.id)
        .then(({ data }) => {
          this.avaliacao = data;
        })
        .finally(() => {
          this.loadingDetalhes = false;
        });
    },
  },
  watch: {
    menuOpened(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      if (this.menuOpened && !this.avaliacao) {
        this.getAvaliacao();
      }
    },
  },
};
</script>
